import { ENDPOINTS } from '@config/endpoints';
import { authedJsonFetch, AuthedJsonFetchResult } from '@services/base/authed-json-fetch';
import { PaymentsPostPremiumIsSubscriedRequestData, PaymentsPostPremiumIsSubscriedRequestDto, PaymentsPostPremiumIsSubscriedResponseData, PaymentsPostPremiumIsSubscriedResponseDto } from '@services/dto/payments';
import { paymentsPostPremiumIsSubscriedRequestToDto, paymentsPostPremiumIsSubscriedResponseFromDto } from '@mapping/payments';
type PaymentsPostPremiumIsSubscried = (requestData: PaymentsPostPremiumIsSubscriedRequestData) => AuthedJsonFetchResult<PaymentsPostPremiumIsSubscriedResponseData>;
export const paymentsPostPremiumIsSubscried: PaymentsPostPremiumIsSubscried = requestData => {
  const {
    promise,
    cancel
  } = authedJsonFetch<PaymentsPostPremiumIsSubscriedResponseDto, PaymentsPostPremiumIsSubscriedRequestDto>(ENDPOINTS.clients.premiumSubscription(), {
    method: 'POST',
    data: paymentsPostPremiumIsSubscriedRequestToDto(requestData)
  });
  return {
    promise: promise.then(paymentsPostPremiumIsSubscriedResponseFromDto),
    cancel
  };
};